var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('credit-notes-table',{attrs:{"id":"CPCN1","contract-id":_vm.contractId,"product-id":_vm.productId,"client-id":_vm.clientId}})}
var staticRenderFns = []

export { render, staticRenderFns }